module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.lightboxVisible) ? _c('modal-dialog', {
    attrs: {
      "title": "Viewer",
      "modal-visible": _vm.lightboxVisible,
      "submit-visible": false
    },
    on: {
      "closeModal": function($event) {
        _vm.lightboxVisible = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.lightboxSrc
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.deleteDialog.visible) ? _c('modal-dialog', {
    attrs: {
      "title": "Delete or Remove?",
      "modal-visible": _vm.deleteDialog.visible,
      "submit-visible": true,
      "confirm-button-text": "Remove Only",
      "button-class": "btn-warning"
    },
    on: {
      "confirm": _vm.removeImage,
      "closeModal": function($event) {
        _vm.deleteDialog.visible = false
      }
    }
  }, [_vm._v("\n\n\t\t\tWould you like to delete this image or just remove it from this list?\n\n\t\t\t"), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmDeleteImage
    },
    slot: "footer"
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Delete")])]) : _vm._e(), _vm._v(" "), (!_vm.noThumbs) ? _c('div', {
    staticClass: "thumbs"
  }, _vm._l((_vm.thumbsWithTokens), function(image, index) {
    return _c('div', {
      staticClass: "thumb",
      style: ({
        backgroundImage: 'url(' + _vm.apiBase + 'image/serve/' + image + '?t=' + _vm.rand + ')'
      })
    }, [(!_vm.locked) ? _c('div', {
      staticClass: "buttons"
    }, [_c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (_vm.copyImageUrl(image)),
        expression: "copyImageUrl(image)",
        arg: "copy"
      }],
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "title": "Copy image url to clipboard",
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-copy"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.rotate('left', index, _vm.images)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-rotate-left"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.rotate('right', index, _vm.images)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-rotate-right"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteImage(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (!_vm.multi && _vm.images && _vm.images.length == 0 || _vm.multi) ? _c('upload-field', {
    attrs: {
      "upload-type": _vm.uploadType,
      "upload-msg": _vm.uploadMsg
    },
    on: {
      "uploaded": function($event) {
        _vm.saveUpload($event)
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59bc06a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageUploadField.vue
// module id = 292
// module chunks = 0